
import { Link } from "react-router-dom";

const PricingFooter = () => {
  return (
    <footer className="container mx-auto px-6 py-8 border-t">
      <div className="flex flex-col md:flex-row items-center justify-between">
        <div className="text-gray-600 mb-4 md:mb-0">
          © 2024 ScoutLink.ai. Supporting the startup ecosystem.
        </div>
        <div className="flex space-x-6">
          <Link to="/data" className="text-gray-600 hover:text-gray-900">Data Workspace</Link>
          <Link to="/analytics" className="text-gray-600 hover:text-gray-900">Analytics</Link>
          <Link to="/email" className="text-gray-600 hover:text-gray-900">Email Tools</Link>
          <a href="mailto:hello@scoutlink.ai" className="text-gray-600 hover:text-gray-900">Contact</a>
        </div>
      </div>
    </footer>
  );
};

export default PricingFooter;
